/**
 * Evaluate script code which is returned in snippet (needed for reinitialization of formatters etc.)
 * Our pre-conditions: snippets contains only the script tag.
 */
(function ($) {
    $.nette.ext('scripts-evaluator', {
        init() {
            this.ext('snippets', true).after($.proxy(($snippet) => {
                $el = $($snippet).find('> script');
                if ($el.length === 1 && $($snippet).children().size() === 1) {
                    eval($el[0].innerHTML);
                }
            }, this));
        },
    });
}(jQuery));
